export default {
    'title.activety': 'Activity',
    'title.giftCard': 'Instachef',
    'title.giftCardResult': 'Gift Card Result',
    'title.giftHistory': 'Gift Card History'
}